export const TEXTS = {
  MEDIA_LIST_ITEM_DISLIKE_BUTTON_HINT: 'Исключить',
  MEDIA_LIST_ITEM_RECOVER_BUTTON_HINT: 'Восстановить',
};
